<template>
  <div>
    <div class="d-flex justify-content-between align-items-center bg-white" >
      <h4 class="my-3">Transport # TR-{{ transport.id }}</h4>
      <div class="pt-1">
        <a class="btn btn-sm btn-outline-secondary mr-2" target="_blank" :href="bolUrl(transport.id)"><i class="fa fa-file-invoice"></i> Print BOL</a>
        <button class="btn btn-sm btn-outline-secondary mr-2" @click="save"><i class="fa fa-save"></i> Save</button>
        <button class="btn btn-sm btn-outline-secondary mr-2" @click="$router.push('/transport')"><i class="fa fa-times"></i> Cancel</button>
      </div>
    </div>
    <div>
      <div class="row">
        <div class="col-12 alert alert-warning">Not totally funcational, for demo purposes</div>
      </div> 
      <div class="row">
        <div class="col-4">
          <div class="border-bottom pb-2 mb-2">
            <h6 class="mb-0">CLIENT<br />
              <span class="text-muted">{{ transport.client.name }}</span>
            </h6>
          </div>
          <div class="border-bottom pb-2 mb-2">
            <h6 class="mb-0">PO NUMBER
              <input type="text" class="form-control form-control-sm" v-model="transport.po_number" />
            </h6>
          </div>
          <h6 class="mb-1">STATUS</h6>
          <div>
            <select class="form-control-sm form-control">
              <option>Pending</option>
              <option>Scheduled</option>
              <option>Shipped</option>
              <option>Delivered</option>
            </select>
          </div>
        </div>
        <div class="col-4 border-left">
          <div class="">
            <h6 class="mb-0">
              ORIGIN
              <small><i class="fa fa-edit"></i></small>
            </h6>
            <address class="mt-2">
              {{ transport.origin.name }}<br />
              {{ transport.origin.address }}<br />
              {{ transport.origin.city }},
              {{ transport.origin.state }}
              {{ transport.origin.zip }}
            </address>
            <h6 class="mb-0">
              APPOINTMENT
            </h6>
            <div class="mt-2">
              <datetime
                input-class="form-control form-control-sm"
                v-model="transport.appointment_at"
                type="datetime"
                :use12-hour="true"
                :minute-step="5"
              ></datetime>
              <input
                type="text"
                class="form-control form-control-sm mt-1"
                placeholder="Appointment Notes"
              />
            </div>
          </div>
        </div>
        <div class="col-4 border-left">
          <div class="">
            <h6 class="mb-0">
              DESTINATION
              <small><i class="fa fa-edit"></i></small>
            </h6>
            <address class="mt-2">
              {{ transport.destination.name }}<br />
              {{ transport.destination.address }}<br />
              {{ transport.destination.city }},
              {{ transport.destination.state }}
              {{ transport.destination.zip }}
            </address>
            <h6 class="mb-0">APPOINTMENT</h6>
            <div class="mt-2">
              <datetime
                input-class="form-control form-control-sm"
                v-model="transport.appointment_at"
                type="datetime"
                :use12-hour="true"
                :minute-step="5"
              ></datetime>
              <input
                type="text"
                class="form-control form-control-sm mt-1"
                placeholder="Appointment Notes"
              />
            </div>
          </div>
        </div>        
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card mt-4">
            <table class="table">
              <thead class="thead-light">
                <tr>
                  <th>QTY</th>
                  <th>UNITS</th>
                  <th>GOODS</th>
                  <th>WT (LBS)</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in items"
                  :key="index"
                >
                  <td style="width: 200px;">
                    <input class="form-control form-control-sm" type="number" v-model="transport.total_qty">
                  </td>
                  <td style="width: 200px;">
                    <input class="form-control form-control-sm" type="text" v-model="transport.units">
                  </td>
                  <td>
                    <input class="form-control form-control-sm" type="text" v-model="transport.cargo">
                  </td>
                  <td style="width: 200px;">
                    <input class="form-control form-control-sm" type="number" v-model="transport.weight">
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-6">
          <h6>NOTES</h6>
          <textarea class="form-control form-control-sm" rows="4" v-model="transport.notes"></textarea>
        </div>
        <div class="col-6">
          <h6>BOL SPECIAL INSTRUCTIONS</h6>
          <textarea class="form-control form-control-sm" rows="4" v-model="transport.bol_notes"></textarea>
        </div>
      </div>
    </div>
  
   </div>
</template>

<script>

import moment from 'moment'
import n from '@/libs/notifications'
import api from '@/api'
import { Datetime } from 'vue-datetime'

export default {
  name: 'tranport-detail',
  components: {
    Datetime,
  },

  data() {
    return {
      items: [{}],
      transport: { origin: {}, destination: {}, client: {}, items: [{}]}
    }
  },

  watch: {
    order() {
      this.fetchData()
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {

    bolUrl(id) {
      return `${api.baseUrl}/transport/${id}/bol`
    },

    calendar(date) {
      return moment(date).calendar()
    },

    fetchData() {
      if (this.$route.params && this.$route.params.id) {
        api.get(`/transport/${this.$route.params.id}`).then(res => {
        this.transport = res.data.order
        })
      }
    },

    save() {
      api.post(`/transport/${this.transport.id}`, { order: {
          notes: this.transport .notes,
          bol_notes: this.transport .bol_notes,
          appointment_at: this.transport.appointment_at,
          total_qty: this.transport.total_qty,
          units: this.transport.units,
          cargo: this.transport.cargo,
        }}).then(() => {
        n.success('Transport Save')
      }).catch(err => {
        n.error(`There was an error: ${err}`)
      })
    }
  }
}
</script>

<style>

.sweet-title {
  background: #E9ECEF;
}

</style>